import { render, staticRenderFns } from "./ViewTables.vue?vue&type=template&id=bdbcb992&scoped=true"
import script from "./ViewTables.vue?vue&type=script&lang=js"
export * from "./ViewTables.vue?vue&type=script&lang=js"
import style0 from "./ViewTables.vue?vue&type=style&index=0&id=bdbcb992&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbcb992",
  null
  
)

export default component.exports